export default {
  lang: {
    zh: '中文',
    en: '英语',
    ko: '韩语'
  },
  // logo: require('@/assets/images/icon/logozh.png'),
  footer: {
    title: '版权所有：广东潮博汇商务展览公司  网站备案/许可证：粤ICP备17112694号-1',
    contact: '联系我们',
    address: '公司地址',
    wechat: '微信公众号',
    address_detail: '广东省汕头市澄海区澄江路与玉潭路交接处'
  },
  tab: {
    home: '首页',
    news: '资讯',
    product: '产品',
    selection: '择样',
    mine: '我的'
  },
  menu: {
    home: '潮博汇',
    introduction: '关于我们',
    product: '产品中心',
    news: '新闻资讯',
    newsDetail: '新闻详情',
    contact: '联系我们',
    member: '会员中心',
    basicInfo: '基本信息',
    clientInfo: '客户信息',
    selectionList: '择样清单',
    selectionDetail: '报价详情',
    chooseSample: '择样',
    setting: '系统设置',
    favorite: '收藏样品',
    message: '消息中心',
    mine: '我的'
  },
  title: {
    message: '消息中心',
    clientInfo: '我的客户',
    quotation: '我的报价单',
    customerBill: '客户账号',
    recentlySample: '最近择样清单',
    recommendedQuotation: '择样清单',
    recommendedQuotationNum: '择样单号',
    confirmQuotation: '报价择样清单',
    confirmQuotationNum: '报价择样单号',
    unquotedSample: '已确认择样单数量',
    selectedSample: '已报价择样单数量',
    copySample: '复制择样清单',
    preview: '预览'
  },
  loading: '加载中...',
  button: {
    returnHome: '返回首页',
    returnPrev: '返回上一页',
    addClient: '添加客户',
    addQuotation: '添加报价单',
    copyQuotation: '复制报价单',
    unfreeze: '解冻',
    freeze: '冻结',
    search: '搜索',
    reset: '重置',
    edit: '编辑',
    setPassword: '设置密码',
    recommend: '推荐',
    detail: '详情',
    quote_detail: '报价详情',
    confirmRecommend: '确认推荐',
    filter: '进行筛选',
    delete: '删除',
    exportExcel: '导出excel',
    exportQuotation: '导出择样单',
    printQuotation: '打印择样单',
    checkOrder: '查看确认订单',
    joinAll: '全部加入确认',
    addConfirm: '加入确认',
    more: '更多',
    chooseTheSample: '开始择样',
    cancel: '取消',
    confirm: '确认提交',
    askQuotation: '索要报价',
    setQuote: '设置报价并激活',
    checkQuote: '查看报价设置',
    check: '查看择样',
    online: '在线客服',
    backTop: '回顶部',
    time: '客服时间'
  },
  placeholder: {
    phone: '请输入您的手机号码',
    email: '请输入您的邮箱',
    account: '请输入账号',
    verifiy: '请输入验证码',
    password: '请输入密码',
    setPassword: '请设置密码',
    key: '请输入激活码',
    oldPassword: '请输入旧密码',
    newPassword: '请输入新密码',
    confirmPassword: '请再次输入新密码'
  },
  select: {
    all: '全部',
    unconfirmed: '未确认',
    confirmed: '已确认',
    chooseTheSampleNumber: '择样单号',
    customer: '客户账号',
    code: '展厅编号',
    sampleCode: '产品货号',
    sampleInfo: '产品名称',
    category: '分类',
    price: '价格',
    filter: '筛选'
  },
  tips: {
    title: '温馨提示',
    content: '请使用兼容性较高的谷歌浏览器或360浏览器',
    login: '登录中...',
    deleteFirst: '确认要删除这',
    deleteSecond: '种商品',
    empty: '请添加产品到择样单上',
    deleteTitle: '提示',
    deleteMessage: '确认要删除?',
    noMore: '没有更多了'
  },
  message: {
    phone: '手机号不能为空',
    email: '邮箱不能为空',
    isPhone: '请输入有效的手机号',
    isEmail: '请输入有效的邮箱',
    account: '账号不能为空',
    verifiy: '验证码不能为空',
    password: '密码不能为空',
    setPassword: '密码不能为空',
    key: '激活码不能为空',
    oldPassword: '旧密码不能为空',
    newPassword: '新密码不能为空',
    confirmPassword: '确认密码不能为空',
    noData: '暂无数据',
    match: '对码指令发送成功',
    sendPhone: '发送成功，请在手机短信查收',
    sendEmail: '发送成功，请在邮箱查收',
    getCode: '请获取验证码！',
    401: 'Oh~~您没有浏览这个页面的权限~',
    404: 'Oh~~您的页面好像飞走了~',
    500: 'Oh~~鬼知道服务器经历了什么~',
    client: {
      account: '请输入客户账号',
      nickName: '请输入客户昵称',
      password: '请输入客户密码'
    }
  },
  link: {
  },
  table: {
    client: {
      index: '编号：',
      account: '客户账号',
      nickName: '客户昵称',
      status: '状态',
      operation: '操作',
      copyLink: '复制链接',
      checkLink: '查看链接'
    },
    quotation: {
      quotationNum: '择样单号',
      sectionNum: '产品款数',
      quotationTime: '择样时间',
      company: '公司名称',
      customer: '客户',
      status: '状态',
      customerStatus: '客户状态',
      remark: '备注',
      reply: '回复',
      operation: '操作',
      picture: '图片',
      code: '展厅编号',
      product: '产品名称',
      productCode: '产品货号',
      specifications: '产品规格',
      packSpecifications: '包装规格',
      cartonSpecifications: '外箱规格',
      outerBoxContent: '外箱装量',
      innerBoxQuantity: '内盒数量',
      cuft: '材积',
      volume: '体积',
      package: '包装',
      weight: '毛重/净重',
      venderName: '供应商',
      venderContact: '联系人',
      venderTel: '联系电话',
      venderPhone: '联系手机',
      price: '厂价',
      sPrice: '单价',
      clPrice: '客价',
      boxes: '采购箱数'
    }
  },
  status: {
    unfreeze: '正常',
    freeze: '冻结',
    confirmed: '已确认',
    unconfirmed: '未确认',
    recommended: '已推荐',
    notRecommended: '未推荐',
    replied: '已回复',
    pendingReply: '待回复',
    notRequested: '未索取',
    quoted: '已报价',
    pendingQuotation: '待报价'
  },
  form: {
    copySample: '复制到的择样清单编号',
    client: {
      account: '客户账号',
      nickName: '客户昵称',
      password: '客户密码'
    }
  },
  login: {
    client: '登录',
    title: '登录/注册',
    phone: '手机号码',
    account: '账号',
    email: '邮箱',
    login: '登录',
    company_login: '公司登录',
    client_login: '客户登录',
    get_auth_code: '获取验证码',
    free_register: '新用户注册',
    accomplish: '登录',
    auth_code: '验 证 码',
    password: '密码',
    welcome: '欢迎您',
    logout: '退出',
    phoneLogin: '手机号快捷登录'
  },
  register: {
    title: '注册账号',
    companyZhName: '公司中文名称',
    companyEnName: '公司英文名称',
    companyAddress: '公司地址',
    linkman: '联系人',
    phoneNumber: '手机号码',
    department: '所属部门',
    businessLicense: '营业执照',
    register: '注册',
    backLogin: '返回登陆',
    telephone: '固定电话'
  },
  home: {
    hot_type: '热门类型',
    new_product: '为你推荐最新产品',
    modify: '修改'
  },
  basicInfo: {
    title: '基本信息'
  },
  news: {
    title: '新闻资讯'
  },
  product: {
    all: '全部',
    continue: '继续择样',
    back: '马上添加样品',
    quote: '加入择样单',
    whether_add: '已加入',
    title: '产品中心',
    category: '类型',
    choose_category: '选择',
    placeholder: '产品名称/产品货号/厂家名称',
    sample_center: '产品中心',
    guess_you_like: '猜你喜欢',
    item_no: '产品货号',
    product_standard: '产品规格',
    carton_specifications: '外箱规格',
    pack_specifications: '包装规格',
    inside_box: '装箱内盒',
    quantity: '外箱装量',
    picking: '产品包装',
    gw: '产品毛重',
    nw: '产品净重',
    cuft: '外箱材积',
    volume: '外箱体积',
    credentials: '产品证书',
    choose_sample: '加入择样',
    add_choose_sample: '加入择样清单',
    delete: '删除',
    confirm: '确认择样',
    success_add: '成功加入择样！',
    add_sample: '加入择样！',
    close: '关闭',
    view_sample: '查看择样',
    name: '产品名称',
    code: '编号',
    price: '产品价格',
    mode: '显示模式',
    thumbnail: '缩略图',
    list: '列表',
    updateTime: '更新日期',
    integratedQuery: '综合查询',
    highToLow: '价格从高到低',
    lowToHigh: '价格从低到高',
    priceRange: '价格范围',
    determine: '确定',
    edit: '编辑',
    finsh: '完成',
    params: '详情参数'
  },
  label: {
    productName: '产品名称',
    productCode: '产品货号',
    code: '展厅编号',
    packageWay: '包装方式',
    qty: '装箱数量',
    cartonLength: '外箱长度',
    cartonWidth: '外箱宽度',
    cartonHeight: '外箱高度',
    packageLength: '包装长度',
    packageWidth: '包装宽度',
    packageHeight: '包装高度',
    gw: '毛重',
    nw: '净重',
    approve: '认证',
    price: '价格'
  }
}
